export enum EColumnType {
    rateTitle = 'rateTitle',
    rateId = 'rateId',
    rateXRole = 'rateXRole',
    totalValue = 'totalValue'
}

export enum ETarificationColumnType {
    lineType = 'lineType',
    totalOrBaseOrTaxValue = 'totalOrBaseOrTaxValue',
}

export enum ETarificationLineType {
    total = 'total',
    base = 'base',
    tax = 'tax',
    surcharge = 'surcharge'
}

export enum ETarificationArrayType {
    totalArray = 'totalArray',
    baseArray = 'baseArray',
    taxArray = 'taxArray',
    surchargeArray = 'surchargeArray'
}

export enum ERuleLineType {
    sectorLine = 'sectorLine'
}

export enum ECostOrRetail {
    cost = 'cost',
    retail = 'retail'
}

export enum EPenaltyType {
    BeforeDeparture = "BeforeDeparture",
    AfterDeparture = "AfterDeparture",
}

